import { render, staticRenderFns } from "./PagePadding.vue?vue&type=template&id=7cfb8888&scoped=true&"
import script from "./PagePadding.vue?vue&type=script&lang=js&"
export * from "./PagePadding.vue?vue&type=script&lang=js&"
import style0 from "./PagePadding.vue?vue&type=style&index=0&id=7cfb8888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb8888",
  null
  
)

export default component.exports